export const MASTER_BUSINESS_API_URL = {
  // PUBLIC HOLIDAY SECTION
  ADD_PUBLIC_HOLIDAY: 'public-holiday',
  GET_PUBLIC_HOLIDAY: 'public-holiday/{{public_holiday_id}}',
  GET_PUBLIC_HOLIDAY_PAGING: 'public-holiday/paging',
  GET_PUBLIC_HOLIDAY_ALL: 'public-holiday/export',

  // TRAINING LICENSE SECTION
  ADD_TRAINING_LICENSE: 'training-licence',
  GET_TRAINING_LICENSE: 'training-licence/{{training_licence_id}}',
  GET_TRAINING_LICENSE_PAGING: 'training-licence/paging',
  GET_TRAINING_LICENSE_ALL: 'training-licence/paging',

  // STRESS PROFILE SECTION
  ADD_STRESS_PROFILE: 'business-stress-profile',
  GET_STRESS_PROFILE: 'business-stress-profile/{{business_stress_profile_id}}',
  GET_STRESS_PROFILE_PAGING: 'business-stress-profile/paging',
  GET_STRESS_PROFILE_LOOKUP: 'business-stress-profile/lookup',
  GET_STRESS_PROFILE_ALL: 'business-stress-profile/paging',

  // LEAVE SECTION
  ADD_LEAVE: 'master-leave',
  GET_LEAVE: 'master-leave/{{leave_id}}',
  GET_LEAVE_PAGING: 'master-leave/paging',
  GET_LEAVE_LOOKUP: 'master-leave/lookup',
  GET_LEAVE_ALL: 'master-leave/paging',

  // EMPLOYEE ROLE
  EMPLOYEE_ROLE_LOOKUP: 'business-role/lookup?role_name=employee',

  // BUSINESS ROLE
  GET_BUSINESS_ROLE_PAGING: 'business-role/paging',
  GET_BUSINESS_ROLE_ALL: 'business-role/business-attributes',
  GET_BUSINESS_ROLE:  'business-role/{{business_role_id}}',
  BUSINESS_ROLE: 'business-role/bulk',
  LOG_PAGING: 'client-side-error/paging',
  LOG_EXPORT: 'client-side-error/export',
  SERVER_LOG_PAGING: 'logs/paging',
  SERVER_LOG_EXPORT: 'logs/export',
  DAILY_REPORT_PAGING: 'daily-report/paging',

  NOTIFICATION_PAGING: 'push-notification-log/paging',
  NOTIFICATION_EXPORT: 'push-notification-log/export',
  EMAIL_LOG_PAGING: 'email-log/paging',
  EMAIL_LOG_EXPORT: 'email-log/export',

};
